import React, { useState, useEffect } from 'react'

import Loader from '../FundDetails/Modules/Shared/Loader.jsx'

import { updateArray } from '../../spa/components/investmentProducts/helpers/InvestmentProductsHelper.js'

export default function Table(props) {
  const {
    columns,
    columnSummaries,
    rows,
    isGrouped,
    isRepeated,
    mode = '',
    emptyMessage,
    tableClass = '',
    scrollOffset,
  } = props

  const [selectedGroups, setSelectedGroups] = useState([])
  const [selectedSort, setSelectedSort] = useState(
    (columns.find((c) => c.button) || { button: {} }).button.sort
  )
  const [selectedSortDirection, setSelectedSortDirection] = useState(true)
  const [selectedSortType, setSelectedSortType] = useState(
    (columns.find((c) => c.button) || { button: {} }).button.sortType
  )
  const [selectedSortUpdated, setSelectedSortUpdated] = useState(0)

  useEffect(() => {
    if (selectedSort) {
      sortFunds()
    }
  }, [rows])

  useEffect(() => {
    if (selectedSort) {
      sortFunds()
    }
  }, [selectedSort, selectedSortDirection])

  const sortFunds = () => {
    rows &&
      rows.sort((fund1, fund2) => {
        const a = selectedSortDirection ? fund1 : fund2
        const b = selectedSortDirection ? fund2 : fund1

        // Sort by 'group' first if applicable
        if (isGrouped) {
          const groupCompare = (a['group'] || '').localeCompare(
            b['group'] || '',
            'en',
            { sensitivity: 'base' }
          )

          if (groupCompare) {
            return groupCompare
          }
        }

        // Sort by selected sort
        switch (selectedSortType) {
          case 'number': {
            const aValue =
              typeof a[selectedSort] === 'string'
                ? a[selectedSort] === '-'
                  ? 0.0
                  : parseFloat(a[selectedSort])
                : a[selectedSort]
            const bValue =
              typeof b[selectedSort] === 'string'
                ? b[selectedSort] === '-'
                  ? 0.0
                  : parseFloat(b[selectedSort])
                : b[selectedSort]

            return aValue < bValue ? -1 : aValue > bValue ? 1 : 0
          }
          case 'array':
            return (a[selectedSort][0] || '').localeCompare(
              b[selectedSort][0] || '',
              'en',
              { sensitivity: 'base' }
            )
          case 'func': {
            const sortFunc = columns.find(
              (c) => (c.button || {}).sort === selectedSort
            ).button.sortFunc

            return (sortFunc(a) || '').localeCompare(sortFunc(b) || '', 'en', {
              sensitivity: 'base',
            })
          }
          default:
            return (a[selectedSort] || '').localeCompare(
              b[selectedSort] || '',
              'en',
              { sensitivity: 'base' }
            )
        }
      })

    setSelectedSortUpdated(selectedSortUpdated + 1)
  }

  const onClickSort = (event) => {
    const sort = event.currentTarget.dataset.sort
    const sortType = event.currentTarget.dataset.sortType

    setSelectedSortType(sortType)

    if (sort === selectedSort) {
      setSelectedSortDirection(!selectedSortDirection)
    } else {
      setSelectedSort(sort)
      setSelectedSortDirection(true)
    }
  }

  const onClickToggleGroup = (event) => {
    const group = event.currentTarget.dataset.group

    updateArray(selectedGroups, group, selectedGroups.indexOf(group) < 0)

    setSelectedGroups([...selectedGroups])
  }

  const renderColumnSummary = (columnSummary, i) => {
    return (
      <th
        key={columnSummary.name}
        colSpan={columnSummary.colSpan}
        className={`Table-header ${
          mode?.indexOf('brand-light') < 0 ? 'u-bgColorBrandDark' : ''
        } u-padding2gu u-alignTop u-textNoWrap ${
          columnSummaries.length === i + 1 ? '' : 'bordered'
        }`}
        role="columnheader"
      >
        {columnSummary.content()}
      </th>
    )
  }

  const renderColumnHeader = (column) => {
    return (
      <th
        key={column.name}
        className={`${column.className} ${
          mode?.indexOf('brand-light') < 0 ? 'u-bgColorBrandDark' : ''
        } ${
          column?.button
            ? 'sorting' +
              (selectedSort === column?.button?.sort
                ? selectedSortDirection
                  ? ' is-ascending'
                  : ' is-descending'
                : '')
            : 'sorting_disabled'
        }`}
        role="columnheader"
        aria-label={column.ariaLabel}
      >
        {column.button ? (
          <button
            className={
              column.button.className +
              (selectedSort === column.button.sort ? ' Icon--before' : '')
            }
            data-sort={column.button.sort}
            data-sort-type={column.button.sortType}
            onClick={onClickSort}
          >
            {column.content}
          </button>
        ) : (
          <div className="u-padding2gu">{column.content}</div>
        )}
      </th>
    )
  }

  const renderColumnCell = (column, row, previousRow) => {
    const _isRepeated =
      column.cell.hideRepeated &&
      column.cell.hideRepeated(row) === column.cell.hideRepeated(previousRow)

    if (isRepeated && column.cell.isRepeatedKey) {
      if (!_isRepeated) {
        oddGroup = !oddGroup
        hideBorder = true
      } else {
        hideBorder = false
      }
    }

    return (
      <td
        key={column.name + row.key}
        className={
          'Table-cell ' +
          (column.cell.padding || 'u-paddingHoriz2gu') +
          ' ' +
          (column.cell.className || '') +
          (isRepeated && oddGroup ? ' u-bgColorLight' : '') +
          (isRepeated && !hideBorder && !column.cell.hideRepeated
            ? '  u-borderColorNeutralLight u-borderBottom0 u-borderTop u-borderLeft0 u-borderRight0'
            : '')
        }
      >
        {!_isRepeated && column.cell.content(row)}
      </td>
    )
  }

  let runningGroup = ''
  let previousRow = {}
  let oddGroup = true
  let hideBorder = false

  return (
    <div className={`${scrollOffset ? '' : 'u-overflowX'}`}>
      {rows ? (
        mode && mode.indexOf('portrait') >= 0 ? (
          <div>TODO</div>
        ) : (
          <table
            className={
              'Table Table--reversed Table--sortable ' +
              tableClass +
              (!isRepeated && (!mode || mode.indexOf('no-stripe') < 0)
                ? ' Table--striped'
                : '')
            }
          >
            {(!mode || mode.indexOf('no-header') < 0) && (
              <thead
                className={`Table-head ${scrollOffset ? 'is-sticky' : ''}`}
                style={{ top: scrollOffset ? scrollOffset : null }}
              >
                {columnSummaries && (
                  <tr role="row" className="Table-row">
                    {columnSummaries.map((columnSummary, i) =>
                      renderColumnSummary(columnSummary, i)
                    )}
                  </tr>
                )}
                <tr role="row" className="Table-row">
                  {columns
                    .filter((column) => !column.hide)
                    .map((column) => renderColumnHeader(column))}
                </tr>
              </thead>
            )}
            <tbody className="Table-body">
              {!rows || rows.length < 1 ? (
                <tr className="Table-row">
                  <td className="Table-cell" colSpan={12}>
                    {emptyMessage || 'No rows found with the selected filters.'}
                  </td>
                </tr>
              ) : (
                rows.map((row, i) => {
                  const showGroup = row.group !== runningGroup

                  runningGroup = row.group

                  const rowJsx = (
                    <React.Fragment key={`${i}${row.key}${row.group}`}>
                      {isGrouped && showGroup ? (
                        <tr
                          className="Table-row-group u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft0 u-borderRight0"
                          data-group={row.group}
                          onClick={onClickToggleGroup}
                        >
                          <td className="Table-cell u-paddingVert1gu u-textCenter">
                            <div
                              className={
                                'u-textSizeMsrp4' +
                                (selectedGroups.indexOf(row.group) < 0
                                  ? ' Table-row-group-iconOpen'
                                  : '')
                              }
                            >
                              {selectedGroups.indexOf(row.group) < 0
                                ? '-'
                                : '+'}
                            </div>
                          </td>
                          <td className="Table-cell u-textBold">{row.group}</td>
                          <td className="Table-cell" colSpan={100}></td>
                        </tr>
                      ) : null}
                      {!isGrouped || selectedGroups.indexOf(row.group) < 0 ? (
                        <tr className="Table-row" role="row">
                          {columns
                            .filter((column) => !column.hide)
                            .map((column) =>
                              renderColumnCell(column, row, previousRow)
                            )}
                        </tr>
                      ) : null}
                    </React.Fragment>
                  )

                  previousRow = row

                  return rowJsx
                })
              )}
            </tbody>
          </table>
        )
      ) : (
        <Loader showBackground={false} />
      )}
    </div>
  )
}
